import './Form.scss';

import * as React from 'react';
import { Prompt } from 'react-router-dom';

import { Button, Modal, Typography } from 'antd';
import clsx from 'clsx';

import { useBeforeUnload } from 'lib/hooks';

export interface FormProps {
  alwaysEnabledSubmit?: boolean;
  className?: string;
  isChanged?: boolean;
  warnUnsavedChanges?: boolean;
}

const leaveMessage = 'You have unsaved changes. Do you really want to leave?';

function Form({
  warnUnsavedChanges = false,
  ...props
}: React.PropsWithChildren<FormProps>) {
  const isChanged = props.isChanged ?? false;
  useBeforeUnload(isChanged);

  return (
    <div className={clsx('form', props.className)}>
      {warnUnsavedChanges && (
        <Prompt message={() => (isChanged ? leaveMessage : true)} />
      )}
      {props.children}
    </div>
  );
}

export interface FormModalProps {
  visible: boolean;
  onClose: () => void;
  onGoto: () => void;
  gotoLabel: string;
}

function FormModal({ visible, onClose, onGoto, gotoLabel }: FormModalProps) {
  return (
    <Modal
      open={visible}
      closable={false}
      footer={[
        <Button type="primary" key="Ok" onClick={onClose}>
          Ok
        </Button>,
        <Button key="back" onClick={onGoto}>
          {gotoLabel}
        </Button>
      ]}
    >
      <Typography.Paragraph>Your data was submitted.</Typography.Paragraph>
    </Modal>
  );
}

export { Form, FormModal };
